var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g2, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMx({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 423.721H8.828A8.829 8.829 0 0 1 0 414.893V97.1a8.829 8.829 0 0 1 8.828-8.828h161.839v335.449z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M170.67 88.277h170.67v335.45H170.67z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.721H341.333V88.273h161.839A8.829 8.829 0 0 1 512 97.101v317.793a8.827 8.827 0 0 1-8.828 8.827z",
    fill: "#ff4b55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd250",
    d: "M271.225 263.893L256 271.507v7.613h7.613z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00c3a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 298.151a3.805 3.805 0 0 1-3.807-3.807v-15.225c0-2.104 1.703-3.807 3.807-3.807s3.807 1.703 3.807 3.807v15.225a3.805 3.805 0 0 1-3.807 3.807z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 282.926c-14.951 0-29.388-5.769-40.654-16.244a3.807 3.807 0 0 1-.198-5.378c1.442-1.535 3.848-1.617 5.378-.198 9.854 9.163 22.452 14.207 35.473 14.207 13.021 0 25.619-5.044 35.473-14.207a3.805 3.805 0 1 1 5.18 5.576c-11.264 10.476-25.701 16.244-40.652 16.244z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256 298.151a49.256 49.256 0 0 1-27.336-8.248l4.215-6.342c13.739 9.129 32.503 9.129 46.241 0l4.215 6.342A49.242 49.242 0 0 1 256 298.151z",
    fill: "#00aadc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#732d37",
    d: "M249.973 246.764l-8.405 13.007-1.428 4.281 21.887-5.075z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M232.704 268.236c-10.062 0-22.14-8.468-25.344-27.336l7.509-1.271c2.662 15.69 12.314 21.005 18.11 20.991 1.777-.049 3.631-.662 3.777-1.918.171-1.502.212-1.858-3.769-3.204-2.164-.733-4.617-1.561-6.338-3.531-6.963-7.951 2.464-16.366 6.993-20.41.799-.714 1.13-1.32 1.045-1.55-.249-.651-1.743-1.635-3.427-1.635-4.836 0-8.505-2.732-9.571-7.126-1.108-4.55.985-9.345 4.97-11.404l3.495 6.765c-.934.483-1.304 1.858-1.067 2.84.093.394.32 1.312 2.175 1.312 4.661 0 9.096 2.751 10.538 6.535.617 1.613 1.546 5.806-3.085 9.943-5 4.465-7.992 7.825-6.334 9.717.375.427 1.985.974 3.048 1.331 3.427 1.16 9.806 3.316 8.892 11.289-.573 5.014-5.048 8.493-11.129 8.658-.164 0-.328.004-.488.004z",
    fill: "#aad264"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M263.613 225.83s7.613-15.225-7.613-22.838c0 0 53.289-7.613 45.676 60.902l-.003-.003c-4.996-3.997-12.414-11.302-15.063-17.126l-22.997-13.323v-7.612z",
    fill: "#874150"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256 241.055l38.063 22.838-15.225 7.613L256 248.669v-7.614z",
    fill: "#732d37"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M240.775 218.217a7.614 7.614 0 0 1 7.613 7.613l-.008.008a14.92 14.92 0 0 0-2.795 17.224l1.72 3.441a14.924 14.924 0 0 0 2.795 3.878l21.127 21.127v-10.521a84.42 84.42 0 0 0-8.913-37.757 22.84 22.84 0 0 0-20.427-12.625h-1.111v7.614h-.001v-.002z",
    fill: "#783c46"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M240.775 210.604l-7.613 7.613v7.613s9.056-4.591 12.108-6.054c2.133-1.022 1.745-3.439.521-4.604-.953-.906-5.016-4.568-5.016-4.568z",
    fill: "#ffd250"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M256 313.376c-35.681 0-64.708-29.027-64.708-64.708h7.613c0 31.485 25.611 57.096 57.096 57.096s57.096-25.611 57.096-57.096h7.613c-.002 35.681-29.029 64.708-64.71 64.708z",
    fill: "#aad264"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 199.32,
    cy: 271.258,
    r: 5.166
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.74,
    cy: 289.497,
    r: 5.166
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.29,
    cy: 303.288,
    r: 5.166
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.23,
    cy: 271.258,
    r: 5.166
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.8,
    cy: 289.497,
    r: 5.166
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.25,
    cy: 303.288,
    r: 5.166
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.807 301.957h-7.613a7.614 7.614 0 0 1 0-15.226h7.613a7.613 7.613 0 0 1 0 15.226z",
    fill: "#ffb478"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M286.61 246.764c2.538 7.454 7.93 14.274 15.063 17.126l.003.003C309.289 195.38 256 202.992 256 202.992c38.063 0 30.61 43.772 30.61 43.772z",
    fill: "#9b4b5a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMx);
export default __webpack_public_path__ + "static/media/mx.cba9898902abd5924bd18881a575fbaa.svg";
export { ForwardRef as ReactComponent };